/**
 * axios setup to use mock service
 */

import axios from 'axios';

const axiosServices = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1'
});

// Attach auth token if available
axiosServices.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Propagate HTTP errors with full response for downstream handling
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
);

export default axiosServices;
